export default {
  BASE_API: 'https://shuanghe.nbsft.com/api' // 项目特定的API地址
};
